export enum Condition {
    EQ = "eq",
    NE = "ne",
    GT = "gt",
    GE = "ge",
    LT = "lt",
    LE = "le",
}
